var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
    fill: "#F7931A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5941 7.01C11.7511 5.962 10.9526 5.3985 9.86163 5.0225L10.2156 3.6025L9.35162 3.3875L9.00662 4.77C8.77962 4.713 8.54662 4.66 8.31412 4.607L8.66162 3.2155L7.79762 3L7.44362 4.4195C7.25562 4.3765 7.07063 4.3345 6.89163 4.2895L6.89263 4.285L5.70063 3.9875L5.47063 4.9105C5.47063 4.9105 6.11213 5.0575 6.09862 5.0665C6.44863 5.154 6.51163 5.3855 6.50113 5.5695L6.09812 7.187C6.12212 7.193 6.15313 7.202 6.18812 7.2155L6.09663 7.193L5.53163 9.459C5.48863 9.565 5.38013 9.7245 5.13513 9.664C5.14413 9.6765 4.50713 9.5075 4.50713 9.5075L4.07812 10.4965L5.20312 10.777C5.41212 10.8295 5.61712 10.8845 5.81862 10.936L5.46113 12.372L6.32462 12.587L6.67862 11.167C6.91462 11.2305 7.14363 11.2895 7.36762 11.3455L7.01462 12.7595L7.87863 12.9745L8.23612 11.5415C9.71012 11.8205 10.8181 11.708 11.2846 10.375C11.6606 9.302 11.2661 8.6825 10.4906 8.279C11.0556 8.149 11.4806 7.7775 11.5941 7.01ZM9.61912 9.779C9.35262 10.8525 7.54512 10.272 6.95912 10.1265L7.43413 8.224C8.02013 8.3705 9.89862 8.66 9.61912 9.779ZM9.88662 6.9945C9.64313 7.971 8.13912 7.4745 7.65162 7.353L8.08162 5.628C8.56912 5.7495 10.1406 5.976 9.88662 6.9945Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtc);
export default __webpack_public_path__ + "static/media/btc.fbac3614252d8ed49aa001b7ae949790.svg";
export { ForwardRef as ReactComponent };